import { Typography } from "@material-ui/core"
import { AddCircle } from "@material-ui/icons"
import { PropTypes } from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import DarkButton from "~/components/Common/DarkButton"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AppContext from "~/contexts/App"
import CategoryContext from "~/contexts/Category"
import AddArticleDialog from "~/dialogs/AddArticleDialog"
import AddArticleCard from "~/dialogs/AddArticleDialog/ArticleCard"
import AddPathDialogGeneric from "~/dialogs/AddPathDialogGeneric"

import Box from "../../Common/Box"
import useStyles from "./styles"

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  return result
}

function CategoryArticle({
  article,
  addedArticles,
  setAddedType,
  setAddedArticles,
  index,
}) {
  return (
    <Draggable draggableId={article?.id?.toString()} index={index}>
      {(provided) => {
        return (
          <AddArticleCard
            article={article}
            type="view"
            index={index}
            addedArticles={addedArticles}
            setAddedType={setAddedType}
            setAddedArticles={setAddedArticles}
            provided={provided}
          />
        )
      }}
    </Draggable>
  )
}

CategoryArticle.propTypes = {
  article: PropTypes.object,
  index: PropTypes.number,
  addedArticles: PropTypes.array,
  setAddedType: PropTypes.func,
  setAddedArticles: PropTypes.func,
}

const CategoryArticlesList = React.memo(function CategoryArticlesList({
  articles,
  setAddedType,
  setAddedArticles,
}) {
  return articles?.map((article, index) => (
    <CategoryArticle
      article={article}
      type="view"
      index={index}
      key={article?.id}
      addedArticles={articles}
      setAddedType={setAddedType}
      setAddedArticles={setAddedArticles}
    />
  ))
})

CategoryArticlesList.propTypes = {
  articles: PropTypes.array,
  setAddedType: PropTypes.func,
  setAddedArticles: PropTypes.func,
}

const CategoryChannelContent = () => {
  const classes = useStyles()
  const { openDialog } = useContext(AppContext)

  const { categoryArticles, setCategoryArticles } = useContext(CategoryContext)

  const [categoryDocs, setCategoryDocs] = useState([])
  const [categoryUpdates, setCategoryUpdates] = useState([])

  useEffect(() => {
    setCategoryDocs(categoryArticles?.filter((x) => x?.type === "doc"))
  }, [categoryArticles])

  useEffect(() => {
    setCategoryUpdates(categoryArticles?.filter((x) => x?.type === "update"))
  }, [categoryArticles])

  const addCategoryArticles = async (type) => {
    const newArticles = await openDialog("addArticleDialog", { type: type })
  }

  const renderCategoryDocs = () => {
    function onCategoryDocsDragEnd(result) {
      if (!result.destination) {
        return
      }
      if (result.destination.index === result.source.index) {
        return
      }

      const orderedCategoryDocs = reorder(
        categoryDocs,
        result.source.index,
        result.destination.index,
      )
      setCategoryArticles(orderedCategoryDocs.concat(categoryUpdates))
    }

    return (
      <div className="relative">
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          padding="31px 37px 8px 37px"
          marginBottom="0"
          zIndex={10}
          width="100%"
          height="100%"
        >
          <Box display="flex" flexDirection="row" flexWrap="wrap">
            <Typography
              variant="h3"
              color="primary"
              style={{ fontWeight: "700", marginRight: "8px" }}
            >
              Docs
            </Typography>
            <Typography
              variant="h3"
              color="primary"
              className={classes.orderText}
            >
              In order as they appear
            </Typography>
          </Box>
          <PermissionsWrapper permissionGroup="admin">
            <DarkButton
              onClick={() => addCategoryArticles("doc")}
              // style={path?.published ? { display: "none" } : null}
              startIcon={
                <AddCircle
                  fontSize="small"
                  classes={{ root: classes.addCircle }}
                />
              }
            >
              Add Doc
            </DarkButton>
          </PermissionsWrapper>
        </Box>
        <Box marginLeft={"37px"} marginRight="37px" height={"100%"}>
          {categoryDocs?.length > 0 && (
            <DragDropContext onDragEnd={onCategoryDocsDragEnd}>
              <Droppable droppableId="course">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    <CategoryArticlesList
                      articles={categoryDocs}
                      setAddedType={setCategoryDocs}
                      setAddedArticles={setCategoryArticles}
                    />
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}
          {/* //TODO  */}
          {/* {isLoadingCourses && (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress />
            </Box>
          )} */}
        </Box>
        <AddArticleDialog />
      </div>
    )
  }

  const renderCategoryUpdates = () => {
    function onCategoryUpdatesDragEnd(result) {
      if (!result.destination) {
        return
      }
      if (result.destination.index === result.source.index) {
        return
      }

      const orderedCategoryArticles = reorder(
        categoryUpdates,
        result.source.index,
        result.destination.index,
      )
      setCategoryArticles(orderedCategoryArticles.concat(categoryDocs))
    }

    return (
      <div className="relative">
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          padding="31px 37px 8px 37px"
          marginBottom="10px"
          zIndex={10}
          width="100%"
        >
          <Box display="flex" flexDirection="row" flexWrap="wrap">
            <Typography
              variant="h3"
              color="primary"
              style={{ fontWeight: "700", marginRight: "8px" }}
            >
              Updates
            </Typography>
            <Typography
              variant="h3"
              color="primary"
              className={classes.orderText}
            >
              In order as they appear
            </Typography>
          </Box>
          <PermissionsWrapper permissionGroup="admin">
            <DarkButton
              onClick={() => addCategoryArticles("update")}
              startIcon={
                <AddCircle
                  fontSize="small"
                  classes={{ root: classes.addCircle }}
                />
              }
            >
              Add Update
            </DarkButton>
          </PermissionsWrapper>
        </Box>
        <Box marginLeft={"37px"} marginRight="37px" height={"100%"}>
          {categoryUpdates?.length > 0 && (
            <DragDropContext onDragEnd={onCategoryUpdatesDragEnd}>
              <Droppable droppableId="course">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    <CategoryArticlesList
                      articles={categoryUpdates}
                      setAddedType={setCategoryUpdates}
                      setAddedArticles={setCategoryArticles}
                    />
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}
          {/* //TODO */}
          {/* {isLoadingLearningPaths && (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress />
            </Box>
          )} */}
        </Box>
        <AddPathDialogGeneric />
      </div>
    )
  }

  return (
    <div className="mb-20">
      {renderCategoryDocs()}
      {renderCategoryUpdates()}
    </div>
  )
}

export default CategoryChannelContent
